const ROLE_ADMIN = {
  id: 1,
  value: 'admin',
  label: 'Admin',
};

const ROLE_PSR = {
  id: 2,
  value: 'psr',
  label: 'PSR',
};

const ROLE_MED_DIRECTOR = {
  id: 3,
  value: 'med_director',
  label: 'Medical Admin',
};

const ROLE_NURSE = {
  id: 4,
  value: 'nurse',
  label: 'Nurse',
};

const ROLE_MED_ASSISTANT = {
  id: 5,
  value: 'med_assistant',
  label: 'Medical Assistant',
};

const ROLE_PROVIDER = {
  id: 6,
  value: 'provider',
  label: 'Provider',
};

export {
  ROLE_ADMIN,
  ROLE_PSR,
  ROLE_MED_DIRECTOR,
  ROLE_NURSE,
  ROLE_MED_ASSISTANT,
  ROLE_PROVIDER,
};